import { render, staticRenderFns } from "./contractTemplateFieldConfigure.vue?vue&type=template&id=54dd884e&scoped=true"
import script from "./contractTemplateFieldConfigure.vue?vue&type=script&lang=js"
export * from "./contractTemplateFieldConfigure.vue?vue&type=script&lang=js"
import style0 from "./contractTemplateFieldConfigure.vue?vue&type=style&index=0&id=54dd884e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd884e",
  null
  
)

export default component.exports